<template>
  <div class="home">
    <Top></Top>
    <Menu v-if="$store.state.isShowMenu"></Menu>
    <div class="home_body">
      <div class="nav">
        <!--        <a href="javascript:;" class="add_btn" @click="showTest">添加下载链接</a>-->
        <div
          :class="{
            nav_item: true,
            nav_download: true,
            active: nav_type == 'download' ? true : false,
            nav_item_un:
              ischanges == false && nav_type !== 'download' ? true : false,
          }"
          @click="ischanges == true ? changeNavType('download') : ''"
        >
          正在下载
          <font v-if="$store.state.downloadTaskCount > 0"
            >({{ $store.state.downloadTaskCount }})</font
          >
        </div>
        <div
          :class="{
            nav_item: true,
            nav_done: true,
            active: nav_type == 'done' ? true : false,
            nav_item_un:
              ischanges == false && nav_type !== 'done' ? true : false,
          }"
          @click="ischanges == true ? changeNavType('done') : ''"
        >
          下载完成
          <font v-if="$store.state.doneTaskCount > 0"
            >({{ $store.state.doneTaskCount }})</font
          >
        </div>
        <div
          :class="{
            nav_item: true,
            nav_del: true,
            active: nav_type == 'del' ? true : false,
            nav_item_un: ischanges == false ? true : false,
          }"
          @click="ischanges == true ? changeNavType('del') : ''"
          v-if="false"
        >
          垃圾箱
          <font v-if="$store.state.delTaskCount > 0"
            >({{ $store.state.delTaskCount }})</font
          >
        </div>
        <div class="nav_servie_alert" v-if="isShowUserService">
          <div class="nav_service_qrcode"></div>
          <div class="nav_service_tips">关注公众号，手机管理</div>
        </div>
        <div
          class="nav_dpsj_advertising"
          v-if="
            isShowAdvertising &&
            $store.state.isLogin &&
            $store.state.user.left == 0 &&
            $store.state.user.target_down > $store.state.user.basic_down
          "
        >
          <div
            class="nav_dpsj_advertising_close"
            @click="closeAdvertising"
          ></div>
          <div class="nav_dpsj_advertising_box" @click="showDpsj">
            <!--						<div class="nav_dpsj_advertising_title">您的宽带可升级至</div>-->
            <!--						<div class="nav_dpsj_advertising_speed">-->
            <!--							<font>{{$store.state.user.target_down/1024}}</font>M-->
            <!--						</div>-->
            <!--						<div class="nav_dpsj_advertising_btn" @click="showDpsj">-->
            <!--							<span>9.9</span>元升级-->
            <!--						</div>-->
          </div>
        </div>
        <!-- <div
          class="nav_dpsj"
          :style="{
            bottom:
              $store.state.isLogin &&
              $store.state.user.pid &&
              ($store.state.user.cid == 110 ||
                ($store.state.user.cid == 101 && $store.state.user.did == 103))
                ? ''
                : '90px',
          }"
          @click="showDpsj"
        >
          大鹏提速
        </div> -->
        <!-- <div
          class="nav_jdb"
          v-if="
            $store.state.isLogin &&
            $store.state.user.pid &&
            $store.state.user.cid != 111
          "
          @click="showJdb"
        >
          小宝驿站
        </div> -->
        <div class="nav_questions" @click="showQuestions" v-if="false">
          常见问题
        </div>
        <div class="nav_install" @click="showInstall">下载插件</div>
        <div class="nav_service" @click="showUserService">
          手机版本
          <div class="nav_service_hot"></div>
        </div>
      </div>
      <div class="body_wrap">
        <div class="body_main">
          <List
            type="download"
            @ChangeStatus="ChangeStatus"
            @checkedFinish="checkedFinish"
            v-show="nav_type == 'download'"
          ></List>
          <List
            type="done"
            @ChangedoneStatus="ChangedoneStatus"
            @checkeddoneFinish="checkeddoneFinish"
            v-show="nav_type == 'done'"
          ></List>
          <List type="del" v-show="nav_type == 'del'"></List>
          <div class="body_bottom">
            <div class="body_bottom_speed">{{ $store.state.allSpeed }}/s</div>
            <div class="body_bottom_support">超级好用的远程下载工具</div>
          </div>
        </div>
      </div>
    </div>
    <Login
      v-if="
        !$store.state.isLogin &&
        !$store.state.isShowNotice &&
        !$store.state.alertError.text
      "
    ></Login>
    <Add v-if="$store.state.isShowAdd"></Add>
    <Setting v-if="$store.state.isShowSetting"></Setting>
    <Loading v-if="$store.state.isShowLoading"></Loading>
    <AlertToast v-if="$store.state.alertToast.text"></AlertToast>
    <AlertError v-if="$store.state.alertError.text"></AlertError>
    <AlertConfirm v-if="$store.state.alertConfirm.text"></AlertConfirm>
    <AlertOffline
      v-if="$store.state.isShowOffline && !$store.state.isShowNotice"
    ></AlertOffline>
    <JdbNotice v-if="$store.state.isShowJdbNotice"></JdbNotice>
    <Notice v-if="$store.state.isShowNotice"></Notice>
    <Notice type="only" v-if="$store.state.isShowNoticeOnly"></Notice>
    <Install @Close="closeInstall" v-if="isShowInstall"></Install>
  </div>
</template>

<script>
import Top from "@/components/Top.vue";
import List from "@/components/List.vue";
import Menu from "@/components/Menu.vue";
import Login from "@/components/Login.vue";
import Add from "@/components/Add.vue";
import Notice from "@/components/Notice.vue";
import Setting from "@/components/Setting.vue";
import AlertToast from "@/components/AlertToast.vue";
import AlertError from "@/components/AlertError.vue";
import AlertConfirm from "@/components/AlertConfirm.vue";
import AlertOffline from "@/components/AlertOffline.vue";
import Loading from "@/components/Loading.vue";
import JdbNotice from "@/components/JdbNotice.vue";
import Install from "@/components/Install.vue";

import { mapActions } from "vuex";
import common from "@/common";

export default {
  name: "Home",
  data: function () {
    return {
      nav_type: "download",
      is_load_done_list: false,
      is_load_del_list: false,
      isShowAdvertising: false,
      isShowUserService: false,
      isShowInstall: false,
      ischanges: true,
    };
  },
  components: {
    Top,
    List,
    Menu,
    Login,
    Add,
    Notice,
    Setting,
    AlertToast,
    AlertError,
    AlertConfirm,
    AlertOffline,
    Loading,
    JdbNotice,
    Install,
  },
  watch: {
    "$store.state.user.pid": function (newVal) {
      if (newVal) {
        let pidInfo = this.getInfoFromPid(this.$store.state.user.pid);
        this.$store.state.user.cid = pidInfo.cid;
        this.$store.state.user.did = pidInfo.did;

        if (this.$store.state.isLogin && this.$store.state.user.pid) {
          this.init();
        }
      }
    },
    "$store.state.isLogin": function (newVal) {
      if (newVal && this.$store.state.user.pid) {
        this.init();
      }
    },
    "$store.state.alertToast.text": function (newVal) {
      if (newVal == "设备绑定成功") {
        if (this.$store.state.isLogin && this.$store.state.user.pid) {
          this.init();
        }
      }
    },
    // "$store.state.localApiHost": function(newVal) {
    // 	if (newVal) {
    // 		this.init();
    // 	}
    // }
  },
  methods: {
    ...mapActions([
      "getTaskList",
      "syncTaskProgress",
      "getRptAgree",
      "showLoading",
      "hideLoading",
      "getJdbConfig",
      "sendUserLog",
      "cleanList",
      "getDevJdbStatus",
      "showAdvertising",
      "getTaskSub",
      "postTaskSub",
    ]),

    getInfoFromPid: function (pid) {
      let data = {
        cid: null,
        did: null,
      };
      if (pid.length > 6) {
        data.cid = parseInt(pid.substr(-6, 2), 16);
        data.did = parseInt(pid.substr(-4, 2), 16);
      }
      return data;
    },
    changeNavType: function (type) {
      let _that = this;
      _that.nav_type = type;
      if (type == "done" && !_that.is_load_done_list) {
        _that.is_load_done_list = true;
        _that.getTaskList([1, 0, 20]);
      } else if (type == "del" && !_that.is_load_del_list) {
        _that.is_load_del_list = true;
        _that.getTaskList([2, 0, 20]);
      }
    },
    ChangeStatus: function () {
      let _that = this;
      _that.ischanges = false;
    },
    checkedFinish: function () {
      let _that = this;
      _that.ischanges = true;
    },
    ChangedoneStatus: function () {
      let _that = this;
      _that.ischanges = false;
    },
    checkeddoneFinish: function () {
      let _that = this;
      _that.ischanges = true;
    },
    closeInstall: function () {
      let _that = this;
      _that.isShowInstall = false;
    },
    showInstall: function () {
      let _that = this;
      _that.isShowInstall = true;
    },
    showQuestions: function () {
      let _that = this;
      _that.$store.state.isShowQuestions = true;
    },
    showUserService: function () {
      let _that = this;
      _that.isShowUserService = !this.isShowUserService;
      _that.sendUserLog(["showUserService", ""]);
    },
    showMenu: function () {
      let _that = this;
      _that.$store.state.isShowMenu = true;
      _that.sendUserLog(["showMenu", ""]);
    },
    closeAdvertising: function () {
      let _that = this;
      _that.sendUserLog(["closeAdvertising", ""]);
      _that.isShowAdvertising = !this.isShowAdvertising;
      // console.log(_that.isShowAdvertising);
      let closeTimestamp = new Date().getTime();
      localStorage.setItem("owdl-closetime", closeTimestamp);
      // console.log("关闭时间："+closeTimestamp);
    },
    showJdb: function () {
      let _that = this;
      _that.$store.state.isShowJdbAlert = true;
      _that.sendUserLog(["showJdb", ""]);
    },
    showDpsj: function () {
      let _that = this;
      _that.$store.state.isShowDpsjAlert = true;
      _that.sendUserLog(["showDpsj", ""]);
    },
    init: function () {
      let _that = this;
      _that.$store.state.isShowLoading = true;
      _that.cleanList();
      _that.getTaskList([
        0,
        0,
        20,
        function (err, data) {
          // _that.sendUserLog([
          // 	"getTaskListDownload",
          // 	JSON.stringify(data),
          // ]);
          _that.$store.state.isShowLoading = false;
        },
      ]);
      _that.getTaskList([
        1,
        0,
        20,
        function (err, data) {
          // _that.sendUserLog([
          // 	"getTaskListDone",
          // 	JSON.stringify(data),
          // ]);
        },
      ]);
      _that.getTaskList([
        2,
        0,
        20,
        function (err, data) {
          // _that.sendUserLog(["getTaskListDel", JSON.stringify(data)]);
        },
      ]);
      _that.getJdbConfig([]);
      // _that.checkSystemNotice();
      // _that.checkAdvertising();
      _that.checkJdbNotice();
      // _that.checkNotice();
    },
    checkAdvertising: function () {
      let _that = this;
      let onetime = 24 * 60 * 60 * 1000;
      let closeTimestamp = localStorage.getItem("owdl-closetime")
        ? localStorage.getItem("owdl-closetime")
        : 0;
      let nowTimestamp = new Date().getTime();
      // let newTimestamp = localStorage.getItem("owdl-closetime")*1+onetime;
      // localStorage.setItem("owdl-newtime", newTimestamp);
      // console.log(onetime);
      // console.log("新的时间:"+newTimestamp);
      if (nowTimestamp - closeTimestamp > onetime) {
        _that.isShowAdvertising = true;
        _that.showAdvertising([
          function () {
            // console.log(_that.$store.state.user.left);
          },
        ]);
      } else {
        _that.isShowAdvertising = false;
      }
      // console.log(_that.isShowAdvertising);
    },
    showNotice: function () {
      let _that = this;
      _that.$store.state.isShowNotice = true;
      _that.sendUserLog(["showMenu", ""]);
    },
    hideNotice: function () {
      this.$store.state.isShowNotice = false;
    },
    checkJdbNotice: function () {
      let _that = this;
      _that.getDevJdbStatus([
        function () {
          console.log(
            "_that.$store.state.user.jdbStatus",
            _that.$store.state.user.jdbStatus
          );
          if (
            _that.$store.state.user.jdbStatus != "on" &&
            _that.$store.state.user.cid == 101 &&
            _that.$store.state.user.did == 103
          ) {
            _that.$store.state.isShowJdbNotice = true;
          }
        },
      ]);
    },
    checkSystemNotice: function () {
      let _that = this;
      if (_that.$store.state.user.cid != 110) {
        return;
      }
      let timestamp = new Date().getTime() / 1000;
      let lastTimestamp = localStorage.getItem("owdl-system-notice-timestamp");
      lastTimestamp = lastTimestamp ? parseInt(lastTimestamp) : 0;
      if (!lastTimestamp) {
        localStorage.setItem("owdl-system-notice-timestamp", timestamp);
        _that.$store.state.alertConfirm.text =
          "群晖DSM7.0 beta版还未支持玩物下载套件，暂不推荐升级。";
      }
    },
    checkNotice: function () {
      let _that = this;
      if (!_that.$store.state.user.pid) {
        return;
      }
      _that.getRptAgree([
        function (err, data) {
          _that.hideLoading();
          if (!err) {
            // console.log(data);
            if (data.rtn == 0) {
              if (data.Agree) {
                _that.hideNotice();
              } else {
                _that.showNotice();
              }
            }
          }
        },
      ]);
    },
  },
  mounted: function () {
    let _that = this;
    _that.$store.state.isShowLoading = false;
    // _that.init();
    setInterval(function () {
      _that.syncTaskProgress();
    }, 3000);
    setInterval(function () {
      if (_that.$store.state.user.pid) {
        _that.getTaskList([0, 0, 20]);
      }
    }, 5000);
    setInterval(function () {
      if (_that.$store.state.user.pid) {
        _that.getTaskList([1, 0, 20]);
      }
    }, 30000);
    setInterval(function () {
      if (_that.$store.state.user.pid) {
        _that.getTaskList([2, 0, 20]);
      }
    }, 60000);
  },
};
</script>

<style lang="less" scoped>
.home {
  padding-top: 60px;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(45deg, #3cacee, #3f5daf, #3f5daf, #3cacee);
  background-image: url(../assets/bg.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 101% 100%;

  .home_body {
    position: relative;
    height: 100%;
    width: 100%;

    .nav {
      width: 180px;
      height: 100%;
      overflow-x: hidden;
      padding-top: 40px;
      position: absolute;
      left: 0;
      top: 0;
      box-sizing: border-box;
      .nav_item {
        height: 50px;
        line-height: 50px;
        color: #ffffff;
        font-size: 14px;
        padding-left: 52px;
        border-left: 4px solid rgba(0, 0, 0, 0);
        background-position: 27px center;
        background-repeat: no-repeat;
        background-size: 14px 14px;
      }
      .nav_item_un {
        visibility: hidden;
      }
      .nav_item.active,
      .nav_item:hover {
        background-color: #ffffff;
        color: #0793dd;
        border-left: 4px solid #f9c03c;
        cursor: pointer;
      }
      .nav_item:hover {
        // background-color: rgba(255, 255, 255, 0.5);
        background-color: #f6f6f6;
        border-left: 4px solid #06a8ff;
      }
      .nav_download {
        background-image: url(../assets/nav_download.png);
      }
      .nav_download.active,
      .nav_download:hover {
        background-image: url(../assets/nav_download_active.png);
      }
      .nav_done {
        background-image: url(../assets/nav_done.png);
      }
      .nav_done.active,
      .nav_done:hover {
        background-image: url(../assets/nav_done_active.png);
      }
      .nav_del {
        background-image: url(../assets/nav_del.png);
      }
      .nav_del.active,
      .nav_del:hover {
        background-image: url(../assets/nav_del_active.png);
      }
      .nav_dpsj_advertising {
        position: absolute;
        height: 120px;
        width: 180px;
        // bottom: 120px;
        bottom: 150px;
        background-image: url(../assets/dpsj_advertising.png);
        background-repeat: no-repeat;
        background-size: 170px 110px;
        background-position: center;
        display: flex;
        flex-direction: column;
      }
      .nav_dpsj_advertising_box {
        margin: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        height: 90%;
        cursor: pointer;
      }
      .nav_dpsj_advertising_close {
        height: 15px;
        width: 15px;
        position: absolute;
        top: 8px;
        right: 6px;
        background-image: url(../assets/jdb_notice_close.png);
        background-repeat: no-repeat;
        background-size: 100%;
        cursor: pointer;
      }
      .nav_dpsj_advertising_speed font {
        font-size: 30px;
      }
      .nav_dpsj_advertising_title,
      .nav_dpsj_advertising_speed {
        color: #0092fe;
        background-image: -webkit-linear-gradient(left, #38d0fd, #0092fe);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;
      }
      .nav_dpsj_advertising_btn {
        width: 100px;
        height: 30px;
        color: #fff;
        background-size: 100%;
        background-image: url(../assets/dpsj_advertisingn_btn.png);
        background-repeat: no-repeat;
        text-align: center;
        font-size: 12px;
        cursor: pointer;
      }

      .nav_dpsj_advertising_btn span {
        font-weight: bold;
        font-size: 16px;
      }
      .nav_jdb {
        position: absolute;
        width: 80px;
        // bottom: 90px;
        bottom: 120px;
        bottom: 90px;
        left: 50px;
        color: #ffffff;
        font-size: 12px;
        padding-left: 20px;
        background-image: url(../assets/jdxb_icon.png);
        background-size: 14px 16px;
        background-position: left center;
        background-repeat: no-repeat;
      }

      .nav_jdb:hover {
        opacity: 0.8;
        cursor: pointer;
      }
      .nav_questions {
        position: absolute;
        width: 80px;
        bottom: 90px;
        left: 50px;
        color: #ffffff;
        font-size: 12px;
        padding-left: 20px;
        background-image: url(../assets/questions_icon.png);
        background-size: 18px 18px;
        background-position: left center;
        background-repeat: no-repeat;
      }
      .nav_questions:hover {
        opacity: 0.8;
        cursor: pointer;
      }
      .nav_install {
        position: absolute;
        width: 80px;
        bottom: 60px;
        left: 50px;
        color: #ffffff;
        font-size: 12px;
        padding-left: 20px;
        background-image: url(../assets/install_icon.png);
        background-size: 18px 18px;
        background-position: left center;
        background-repeat: no-repeat;
        z-index: 7;
      }
      .nav_install:hover {
        opacity: 0.8;
        cursor: pointer;
      }

      .nav_dpsj {
        position: absolute;
        width: 82px;
        // bottom: 60px;
        bottom: 90px;
        left: 50px;
        // color: #6bf8ff;
        color: #ffffff;
        font-size: 12px;
        padding-left: 20px;
        background-image: url(../assets/dpts_icon_white.png);
        background-size: 18px 18px;
        background-position: left center;
        background-repeat: no-repeat;
      }

      .nav_dpsj:hover {
        opacity: 0.8;
        cursor: pointer;
      }

      .nav_service {
        position: absolute;
        width: 80px;
        bottom: 30px;
        left: 50px;
        color: #ffffff;
        font-size: 12px;
        padding-left: 20px;
        // background-image: url(../assets/user_service_icon.png);
        background-image: url(../assets/phone_icon.png);
        background-size: 11px 16px;
        background-position: left center;
        background-repeat: no-repeat;
        z-index: 7;
        .nav_service_hot {
          position: absolute;
          right: 0px;
          top: -5px;
          width: 28px;
          height: 14px;
          background-image: url(../assets/phone_hot_icon.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
      .nav_service:hover {
        opacity: 0.8;
        cursor: pointer;
      }

      .nav_servie_alert {
        width: 130px;
        position: absolute;
        left: 15px;
        bottom: 60px;
        padding: 20px 10px;
        text-align: center;
        background-color: #ffffff;
        box-shadow: 0px 0px 5px #666666;
        border-radius: 5px;
        z-index: 7;

        .nav_service_qrcode {
          width: 100px;
          height: 100px;
          background-color: #eeeeee;
          margin: 0 auto;
          background-image: url(../assets/owdl_qrcode.jpg);
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center center;
        }
        .nav_service_tips {
          text-align: center;
          color: #333333;
          font-size: 12px;
          margin-top: 10px;
        }
      }
    }

    .body_wrap {
      padding-left: 180px;
      padding-right: 10px;
      padding-bottom: 10px;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      .body_main {
        background-color: #ffffff;
        width: 100%;
        height: 100%;
        position: relative;

        .body_bottom {
          width: 100%;
          height: 30px;
          background-color: #f7f9ff;
          position: absolute;
          left: 0;
          bottom: 0;
          .body_bottom_speed {
            color: #999999;
            font-size: 12px;
            height: 30px;
            line-height: 30px;
            margin-left: 10px;
            padding-left: 20px;
            background-image: url(../assets/bottom_speed_icon.png);
            background-position: left center;
            background-repeat: no-repeat;
            background-size: 14px 12px;
            float: left;
          }
          .body_bottom_support {
            color: #888888;
            font-size: 12px;
            height: 30px;
            line-height: 30px;
            padding-left: 25px;
            background-image: url(../assets/owdl_bottom_logo.png);
            background-position: left 9px;
            background-repeat: no-repeat;
            background-size: 20px 10px;
            float: right;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>